export const actionTypes = {
  SET_USER_NOTES: "SET_USER_NOTES",
  SET_ARCHIVE_NOTES: "SET_ARCHIVE_NOTES",
  SET_NOTES_AND_ARCHIVE_NOTES: "SET_NOTE_AND_ARCHIVE_NOTES",
  SET_DATE_SORT_VALUE: "SET_DATE_SORT_VALUE",
};
